import { FC, PropsWithChildren } from 'react';

const Development: FC<PropsWithChildren> = ({ children }) => {
    const isDev = process.env.NODE_ENV === 'development';
    return isDev ? <>{children}</> : null;
};

export default Development;